import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ErrorState } from './error.state';

export const getErrorFeatureState = createFeatureSelector('error');

export const selectErrorMessage = createSelector(
  getErrorFeatureState,
  (state: ErrorState) => state.message
);

export const selectErrorComponentData = createSelector(
  getErrorFeatureState,
  (state: ErrorState) => state.errorComponentData
);

export const selectIsLoading = createSelector(
  getErrorFeatureState,
  (state: ErrorState) => state.isLoading
);
